import styles from './Tabs.scss';

import cx from 'classnames';
import React, { useState } from 'react';

import { TextV2 } from 'src/components/TextV2/TextV2';
import { Bundles } from 'src/services/cms/bundleTypes';
import { TagFields } from '../../types';

interface TabsProps extends TagFields {
  bundles: Bundles;
}

export const Tabs: React.FC<TabsProps> = ({ bundles, children, bundleWithTag, showTag, tagText, tagBackgroundColor }) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const tabButtonClickHandler = (index: number) => {
    setSelectedTab(index);
  };

  return (
    <div className={styles.tabs}>
      <div className={styles.tabsBar}>
        {bundles.map((bundle, index) => {
          const isThisBundleWithTag = bundleWithTag && bundleWithTag.id === bundle.id;
          const tagShouldBeShown = isThisBundleWithTag && showTag && tagText;

          return (
            <button
              className={cx(styles.tabsButton, { [styles.tabsButtonActive]: (selectedTab === index) })}
              onClick={() => tabButtonClickHandler(index)}
              key={index}
              data-test="tabs-button"
            >
              {tagShouldBeShown && (
                <TextV2
                  className={styles.tabsTag}
                  style={{ backgroundColor: tagBackgroundColor }}
                  data-test="tabs-button-tag"
                  value={tagText}
                  variant="eyebrow"
                />
              )}
              <TextV2 value={bundle.title} variant="sub-nav" />
            </button>
          );
        })}
      </div>

      {children && children[selectedTab]}
    </div>
  );
};
